import type { LangMap } from "./index";

export const library: LangMap = {
  it: {
    folders: {
      newFolder: "Nuova cartella",
      searchPlaceholder: "Cerca {{item}}…",
      loading: "Caricamento…",
      emptyTitle: "Nessun {{item}} ancora. Creane uno per iniziare.",
      rename: "Rinomina",
      move: "Sposta",
      duplicate: "Duplica",
      delete: "Elimina",
      deleteFolderConfirm: "Eliminare la cartella? Gli elementi al suo interno resteranno senza cartella.",
      deleteItemConfirm: "Eliminare {{item}}?",
      folderCreated: "Cartella creata",
      renamed: "Rinominata",
      folderDeleted: "Cartella eliminata",
      itemRenamed: "Rinominato",
      itemDeleted: "Eliminato",
      duplicated: "Duplicato",
      moved: "Spostato",
      noFolder: "Senza cartella",
      newFolderDialogTitle: "Nuova cartella",
      newFolderPlaceholder: "Es. Storia, Matematica, Verifiche…",
      cancel: "Annulla",
      create: "Crea",
      renameDialogTitle: "Rinomina",
      save: "Salva",
      moveDialogTitle: "Sposta in cartella",
      noFoldersYet: "Nessuna cartella. Creane una prima.",
      empty: "Vuota",
      untitled: "Senza titolo",
      duplicateSuffix: "(copia)",
    },
    chat: {
      title: "Cronologia chat",
      description: "Tutte le tue conversazioni, ordinate dalla più recente.",
      searchPlaceholder: "Cerca per parola chiave…",
      newChat: "Nuova",
      loading: "Carico…",
      noResults: "Nessuna conversazione trovata.",
      untitled: "Senza titolo",
      rename: "Rinomina",
      delete: "Elimina",
      deleteConfirm: "Eliminare questa conversazione?",
      deleted: "Conversazione eliminata",
      loadError: "Errore caricamento",
      buckets: {
        today: "Oggi",
        yesterday: "Ieri",
        last7Days: "Ultimi 7 giorni",
        lastMonth: "Ultimo mese",
        older: "Più vecchie",
      },
    },
    schedule: {
      dayLabels: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
      paywallTitle: "Orario scolastico da foto",
      paywallDescription: "Scatta una foto all'orario sul diario, l'IA lo trascrive e ti manda il promemoria dei compiti del giorno dopo.",
      photoTooLarge: "Foto troppo grande (max 8MB)",
      extractedSuccess: "Estratte {{count}} ore. Controlla e salva.",
      extractError: "Impossibile leggere la foto",
      notAuthenticated: "Non autenticato",
      invalidTime: 'Orario non valido per "{{subject}}" (usa HH:MM).',
      invalidDay: 'Giorno non valido per "{{subject}}".',
      invalidPeriod: 'Ora non valida per "{{subject}}".',
      duplicatePeriod: "Ci sono due materie nella stessa ora ({{day}} ora {{period}}). Sistemale prima di salvare.",
      saved: "Orario salvato",
      title: "Orario scolastico",
      subtitle: "Foto → trascrizione IA → modifica → promemoria compiti automatico",
      cancel: "Annulla",
      edit: "Modifica",
      newPhoto: "Nuova foto",
      takePhoto: "Scatta",
      timePlaceholder: "08:00",
      subjectPlaceholder: "Materia",
      roomPlaceholder: "Aula",
      addPeriod: "Aggiungi ora",
      noScheduleYet: "Nessun orario ancora. Scatta una foto al diario per iniziare.",
      homeworkFor: "Compiti per {{date}}",
      reminderInApp: "Ti mostreremo un promemoria in-app il giorno prima.",
      subjectShort: "Materia",
      taskPlaceholder: "Compito…",
      reminderToastTitle: "📚 Compiti per domani ({{count}})",
      reminderToastMore: " +{{count}} altri",
    },
  },
  en: {
    folders: {
      newFolder: "New folder",
      searchPlaceholder: "Search {{item}}…",
      loading: "Loading…",
      emptyTitle: "No {{item}} yet. Create one to get started.",
      rename: "Rename",
      move: "Move",
      duplicate: "Duplicate",
      delete: "Delete",
      deleteFolderConfirm: "Delete this folder? Items inside it will remain without a folder.",
      deleteItemConfirm: "Delete {{item}}?",
      folderCreated: "Folder created",
      renamed: "Renamed",
      folderDeleted: "Folder deleted",
      itemRenamed: "Renamed",
      itemDeleted: "Deleted",
      duplicated: "Duplicated",
      moved: "Moved",
      noFolder: "No folder",
      newFolderDialogTitle: "New folder",
      newFolderPlaceholder: "E.g. History, Math, Tests…",
      cancel: "Cancel",
      create: "Create",
      renameDialogTitle: "Rename",
      save: "Save",
      moveDialogTitle: "Move to folder",
      noFoldersYet: "No folders yet. Create one first.",
      empty: "Empty",
      untitled: "Untitled",
      duplicateSuffix: "(copy)",
    },
    chat: {
      title: "Chat history",
      description: "All your conversations, sorted from most recent.",
      searchPlaceholder: "Search by keyword…",
      newChat: "New",
      loading: "Loading…",
      noResults: "No conversations found.",
      untitled: "Untitled",
      rename: "Rename",
      delete: "Delete",
      deleteConfirm: "Delete this conversation?",
      deleted: "Conversation deleted",
      loadError: "Loading error",
      buckets: {
        today: "Today",
        yesterday: "Yesterday",
        last7Days: "Last 7 days",
        lastMonth: "Last month",
        older: "Older",
      },
    },
    schedule: {
      dayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      paywallTitle: "School schedule from photo",
      paywallDescription: "Take a photo of your schedule in your diary, AI will transcribe it and send you homework reminders the day before.",
      photoTooLarge: "Photo too large (max 8MB)",
      extractedSuccess: "Extracted {{count}} periods. Check and save.",
      extractError: "Could not read the photo",
      notAuthenticated: "Not authenticated",
      invalidTime: 'Invalid time for "{{subject}}" (use HH:MM).',
      invalidDay: 'Invalid day for "{{subject}}".',
      invalidPeriod: 'Invalid period for "{{subject}}".',
      duplicatePeriod: "There are two subjects in the same period ({{day}} period {{period}}). Fix them before saving.",
      saved: "Schedule saved",
      title: "School schedule",
      subtitle: "Photo → AI transcription → edit → automatic homework reminder",
      cancel: "Cancel",
      edit: "Edit",
      newPhoto: "New photo",
      takePhoto: "Take photo",
      timePlaceholder: "08:00",
      subjectPlaceholder: "Subject",
      roomPlaceholder: "Room",
      addPeriod: "Add period",
      noScheduleYet: "No schedule yet. Take a photo of your diary to get started.",
      homeworkFor: "Homework for {{date}}",
      reminderInApp: "We'll show you an in-app reminder the day before.",
      subjectShort: "Subject",
      taskPlaceholder: "Task…",
      reminderToastTitle: "📚 Homework for tomorrow ({{count}})",
      reminderToastMore: " +{{count}} more",
    },
  },
  es: {
    folders: {
      newFolder: "Nueva carpeta",
      searchPlaceholder: "Buscar {{item}}…",
      loading: "Cargando…",
      emptyTitle: "Todavía no hay {{item}}. Crea uno para empezar.",
      rename: "Renombrar",
      move: "Mover",
      duplicate: "Duplicar",
      delete: "Eliminar",
      deleteFolderConfirm: "¿Eliminar la carpeta? Los elementos que contiene quedarán sin carpeta.",
      deleteItemConfirm: "¿Eliminar {{item}}?",
      folderCreated: "Carpeta creada",
      renamed: "Renombrada",
      folderDeleted: "Carpeta eliminada",
      itemRenamed: "Renombrado",
      itemDeleted: "Eliminado",
      duplicated: "Duplicado",
      moved: "Movido",
      noFolder: "Sin carpeta",
      newFolderDialogTitle: "Nueva carpeta",
      newFolderPlaceholder: "Ej. Historia, Matemáticas, Exámenes…",
      cancel: "Cancelar",
      create: "Crear",
      renameDialogTitle: "Renombrar",
      save: "Guardar",
      moveDialogTitle: "Mover a carpeta",
      noFoldersYet: "Aún no hay carpetas. Crea una primero.",
      empty: "Vacía",
      untitled: "Sin título",
      duplicateSuffix: "(copia)",
    },
    chat: {
      title: "Historial de chat",
      description: "Todas tus conversaciones, ordenadas de la más reciente.",
      searchPlaceholder: "Buscar por palabra clave…",
      newChat: "Nueva",
      loading: "Cargando…",
      noResults: "No se encontraron conversaciones.",
      untitled: "Sin título",
      rename: "Renombrar",
      delete: "Eliminar",
      deleteConfirm: "¿Eliminar esta conversación?",
      deleted: "Conversación eliminada",
      loadError: "Error al cargar",
      buckets: {
        today: "Hoy",
        yesterday: "Ayer",
        last7Days: "Últimos 7 días",
        lastMonth: "Último mes",
        older: "Más antiguas",
      },
    },
    schedule: {
      dayLabels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      paywallTitle: "Horario escolar desde una foto",
      paywallDescription: "Haz una foto del horario en tu agenda, la IA lo transcribe y te envía el recordatorio de deberes del día siguiente.",
      photoTooLarge: "Foto demasiado grande (máx. 8MB)",
      extractedSuccess: "Se extrajeron {{count}} horas. Revisa y guarda.",
      extractError: "No se pudo leer la foto",
      notAuthenticated: "No autenticado",
      invalidTime: 'Hora no válida para "{{subject}}" (usa HH:MM).',
      invalidDay: 'Día no válido para "{{subject}}".',
      invalidPeriod: 'Hora no válida para "{{subject}}".',
      duplicatePeriod: "Hay dos materias en la misma hora ({{day}} hora {{period}}). Corrígelas antes de guardar.",
      saved: "Horario guardado",
      title: "Horario escolar",
      subtitle: "Foto → transcripción IA → edición → recordatorio de deberes automático",
      cancel: "Cancelar",
      edit: "Editar",
      newPhoto: "Nueva foto",
      takePhoto: "Hacer foto",
      timePlaceholder: "08:00",
      subjectPlaceholder: "Materia",
      roomPlaceholder: "Aula",
      addPeriod: "Añadir hora",
      noScheduleYet: "Aún no hay horario. Haz una foto de tu agenda para empezar.",
      homeworkFor: "Deberes para {{date}}",
      reminderInApp: "Te mostraremos un recordatorio en la app el día anterior.",
      subjectShort: "Materia",
      taskPlaceholder: "Deber…",
      reminderToastTitle: "📚 Deberes para mañana ({{count}})",
      reminderToastMore: " +{{count}} más",
    },
  },
  fr: {
    folders: {
      newFolder: "Nouveau dossier",
      searchPlaceholder: "Rechercher {{item}}…",
      loading: "Chargement…",
      emptyTitle: "Aucun(e) {{item}} pour l'instant. Créez-en un(e) pour commencer.",
      rename: "Renommer",
      move: "Déplacer",
      duplicate: "Dupliquer",
      delete: "Supprimer",
      deleteFolderConfirm: "Supprimer le dossier ? Les éléments qu'il contient resteront sans dossier.",
      deleteItemConfirm: "Supprimer {{item}} ?",
      folderCreated: "Dossier créé",
      renamed: "Renommé",
      folderDeleted: "Dossier supprimé",
      itemRenamed: "Renommé",
      itemDeleted: "Supprimé",
      duplicated: "Dupliqué",
      moved: "Déplacé",
      noFolder: "Sans dossier",
      newFolderDialogTitle: "Nouveau dossier",
      newFolderPlaceholder: "Ex. Histoire, Mathématiques, Contrôles…",
      cancel: "Annuler",
      create: "Créer",
      renameDialogTitle: "Renommer",
      save: "Enregistrer",
      moveDialogTitle: "Déplacer vers un dossier",
      noFoldersYet: "Aucun dossier pour l'instant. Créez-en un d'abord.",
      empty: "Vide",
      untitled: "Sans titre",
      duplicateSuffix: "(copie)",
    },
    chat: {
      title: "Historique des discussions",
      description: "Toutes vos conversations, triées de la plus récente.",
      searchPlaceholder: "Rechercher par mot-clé…",
      newChat: "Nouvelle",
      loading: "Chargement…",
      noResults: "Aucune conversation trouvée.",
      untitled: "Sans titre",
      rename: "Renommer",
      delete: "Supprimer",
      deleteConfirm: "Supprimer cette conversation ?",
      deleted: "Conversation supprimée",
      loadError: "Erreur de chargement",
      buckets: {
        today: "Aujourd'hui",
        yesterday: "Hier",
        last7Days: "7 derniers jours",
        lastMonth: "Dernier mois",
        older: "Plus anciennes",
      },
    },
    schedule: {
      dayLabels: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
      paywallTitle: "Emploi du temps à partir d'une photo",
      paywallDescription: "Prenez une photo de l'emploi du temps dans votre agenda, l'IA le transcrit et vous envoie le rappel des devoirs le jour d'avant.",
      photoTooLarge: "Photo trop volumineuse (max 8 Mo)",
      extractedSuccess: "{{count}} heures extraites. Vérifiez et enregistrez.",
      extractError: "Impossible de lire la photo",
      notAuthenticated: "Non authentifié",
      invalidTime: 'Horaire invalide pour "{{subject}}" (utilisez HH:MM).',
      invalidDay: 'Jour invalide pour "{{subject}}".',
      invalidPeriod: 'Heure invalide pour "{{subject}}".',
      duplicatePeriod: "Il y a deux matières à la même heure ({{day}} heure {{period}}). Corrigez-les avant d'enregistrer.",
      saved: "Emploi du temps enregistré",
      title: "Emploi du temps scolaire",
      subtitle: "Photo → transcription IA → modification → rappel automatique des devoirs",
      cancel: "Annuler",
      edit: "Modifier",
      newPhoto: "Nouvelle photo",
      takePhoto: "Prendre une photo",
      timePlaceholder: "08:00",
      subjectPlaceholder: "Matière",
      roomPlaceholder: "Salle",
      addPeriod: "Ajouter une heure",
      noScheduleYet: "Aucun emploi du temps pour l'instant. Prenez une photo de votre agenda pour commencer.",
      homeworkFor: "Devoirs pour {{date}}",
      reminderInApp: "Nous vous montrerons un rappel dans l'application la veille.",
      subjectShort: "Matière",
      taskPlaceholder: "Devoir…",
      reminderToastTitle: "📚 Devoirs pour demain ({{count}})",
      reminderToastMore: " +{{count}} autres",
    },
  },
  de: {
    folders: {
      newFolder: "Neuer Ordner",
      searchPlaceholder: "{{item}} suchen…",
      loading: "Wird geladen…",
      emptyTitle: "Noch keine {{item}}. Erstelle eine(n), um zu beginnen.",
      rename: "Umbenennen",
      move: "Verschieben",
      duplicate: "Duplizieren",
      delete: "Löschen",
      deleteFolderConfirm: "Ordner löschen? Die darin enthaltenen Elemente bleiben ohne Ordner.",
      deleteItemConfirm: "{{item}} löschen?",
      folderCreated: "Ordner erstellt",
      renamed: "Umbenannt",
      folderDeleted: "Ordner gelöscht",
      itemRenamed: "Umbenannt",
      itemDeleted: "Gelöscht",
      duplicated: "Dupliziert",
      moved: "Verschoben",
      noFolder: "Kein Ordner",
      newFolderDialogTitle: "Neuer Ordner",
      newFolderPlaceholder: "Z.B. Geschichte, Mathematik, Tests…",
      cancel: "Abbrechen",
      create: "Erstellen",
      renameDialogTitle: "Umbenennen",
      save: "Speichern",
      moveDialogTitle: "In Ordner verschieben",
      noFoldersYet: "Noch keine Ordner. Erstelle zuerst einen.",
      empty: "Leer",
      untitled: "Ohne Titel",
      duplicateSuffix: "(Kopie)",
    },
    chat: {
      title: "Chatverlauf",
      description: "Alle deine Unterhaltungen, sortiert nach der aktuellsten.",
      searchPlaceholder: "Nach Stichwort suchen…",
      newChat: "Neu",
      loading: "Wird geladen…",
      noResults: "Keine Unterhaltungen gefunden.",
      untitled: "Ohne Titel",
      rename: "Umbenennen",
      delete: "Löschen",
      deleteConfirm: "Diese Unterhaltung löschen?",
      deleted: "Unterhaltung gelöscht",
      loadError: "Fehler beim Laden",
      buckets: {
        today: "Heute",
        yesterday: "Gestern",
        last7Days: "Letzte 7 Tage",
        lastMonth: "Letzter Monat",
        older: "Älter",
      },
    },
    schedule: {
      dayLabels: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
      paywallTitle: "Stundenplan per Foto",
      paywallDescription: "Mach ein Foto vom Stundenplan in deinem Hausaufgabenheft, die KI überträgt ihn und schickt dir am Vortag die Hausaufgaben-Erinnerung.",
      photoTooLarge: "Foto zu groß (max. 8 MB)",
      extractedSuccess: "{{count}} Stunden erkannt. Prüfen und speichern.",
      extractError: "Foto konnte nicht gelesen werden",
      notAuthenticated: "Nicht angemeldet",
      invalidTime: 'Ungültige Uhrzeit für "{{subject}}" (verwende HH:MM).',
      invalidDay: 'Ungültiger Tag für "{{subject}}".',
      invalidPeriod: 'Ungültige Stunde für "{{subject}}".',
      duplicatePeriod: "Es gibt zwei Fächer zur gleichen Stunde ({{day}} Stunde {{period}}). Bitte vor dem Speichern korrigieren.",
      saved: "Stundenplan gespeichert",
      title: "Stundenplan",
      subtitle: "Foto → KI-Übertragung → Bearbeiten → automatische Hausaufgaben-Erinnerung",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      newPhoto: "Neues Foto",
      takePhoto: "Foto aufnehmen",
      timePlaceholder: "08:00",
      subjectPlaceholder: "Fach",
      roomPlaceholder: "Raum",
      addPeriod: "Stunde hinzufügen",
      noScheduleYet: "Noch kein Stundenplan. Mach ein Foto deines Hausaufgabenhefts, um zu beginnen.",
      homeworkFor: "Hausaufgaben für {{date}}",
      reminderInApp: "Wir zeigen dir am Vortag eine Erinnerung in der App.",
      subjectShort: "Fach",
      taskPlaceholder: "Aufgabe…",
      reminderToastTitle: "📚 Hausaufgaben für morgen ({{count}})",
      reminderToastMore: " +{{count}} weitere",
    },
  },
  pt: {
    folders: {
      newFolder: "Nova pasta",
      searchPlaceholder: "Pesquisar {{item}}…",
      loading: "A carregar…",
      emptyTitle: "Ainda não há {{item}}. Cria um para começar.",
      rename: "Renomear",
      move: "Mover",
      duplicate: "Duplicar",
      delete: "Eliminar",
      deleteFolderConfirm: "Eliminar a pasta? Os itens dentro dela ficarão sem pasta.",
      deleteItemConfirm: "Eliminar {{item}}?",
      folderCreated: "Pasta criada",
      renamed: "Renomeada",
      folderDeleted: "Pasta eliminada",
      itemRenamed: "Renomeado",
      itemDeleted: "Eliminado",
      duplicated: "Duplicado",
      moved: "Movido",
      noFolder: "Sem pasta",
      newFolderDialogTitle: "Nova pasta",
      newFolderPlaceholder: "Ex. História, Matemática, Testes…",
      cancel: "Cancelar",
      create: "Criar",
      renameDialogTitle: "Renomear",
      save: "Guardar",
      moveDialogTitle: "Mover para pasta",
      noFoldersYet: "Ainda não há pastas. Cria uma primeiro.",
      empty: "Vazia",
      untitled: "Sem título",
      duplicateSuffix: "(cópia)",
    },
    chat: {
      title: "Histórico de conversas",
      description: "Todas as tuas conversas, ordenadas da mais recente.",
      searchPlaceholder: "Pesquisar por palavra-chave…",
      newChat: "Nova",
      loading: "A carregar…",
      noResults: "Nenhuma conversa encontrada.",
      untitled: "Sem título",
      rename: "Renomear",
      delete: "Eliminar",
      deleteConfirm: "Eliminar esta conversa?",
      deleted: "Conversa eliminada",
      loadError: "Erro ao carregar",
      buckets: {
        today: "Hoje",
        yesterday: "Ontem",
        last7Days: "Últimos 7 dias",
        lastMonth: "Último mês",
        older: "Mais antigas",
      },
    },
    schedule: {
      dayLabels: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"],
      paywallTitle: "Horário escolar a partir de foto",
      paywallDescription: "Tira uma foto ao horário na agenda, a IA transcreve-o e envia-te o lembrete dos trabalhos de casa no dia anterior.",
      photoTooLarge: "Foto demasiado grande (máx. 8MB)",
      extractedSuccess: "Extraídas {{count}} horas. Verifica e guarda.",
      extractError: "Não foi possível ler a foto",
      notAuthenticated: "Não autenticado",
      invalidTime: 'Horário inválido para "{{subject}}" (usa HH:MM).',
      invalidDay: 'Dia inválido para "{{subject}}".',
      invalidPeriod: 'Hora inválida para "{{subject}}".',
      duplicatePeriod: "Há duas disciplinas na mesma hora ({{day}} hora {{period}}). Corrige-as antes de guardar.",
      saved: "Horário guardado",
      title: "Horário escolar",
      subtitle: "Foto → transcrição IA → edição → lembrete automático de trabalhos de casa",
      cancel: "Cancelar",
      edit: "Editar",
      newPhoto: "Nova foto",
      takePhoto: "Tirar foto",
      timePlaceholder: "08:00",
      subjectPlaceholder: "Disciplina",
      roomPlaceholder: "Sala",
      addPeriod: "Adicionar hora",
      noScheduleYet: "Ainda não há horário. Tira uma foto da tua agenda para começar.",
      homeworkFor: "Trabalhos de casa para {{date}}",
      reminderInApp: "Vamos mostrar-te um lembrete na app no dia anterior.",
      subjectShort: "Disciplina",
      taskPlaceholder: "Trabalho…",
      reminderToastTitle: "📚 Trabalhos de casa para amanhã ({{count}})",
      reminderToastMore: " +{{count}} outros",
    },
  },
};
